import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const PaginationNextButton = (props) => {
    const styles = StyleSheet.create({
        moreButton: {
            padding: '14px 0',
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 'bold',
            color: Colors.GrayDarkestB,
            border: `1px solid  ${Colors.GrayDarkest}`,
            borderRadius: 4,
            width: 120,
            margin: '32px 24px 40px',
            backgroundColor: Colors.White,
            cursor: 'pointer',
            [MediaBreakPointUp.SM]: {
                margin: '32px 40px 40px',
            },
        },
    });
    const { getNextPage, classObject, isAvailable } = props;
    return (React.createElement(React.Fragment, null, isAvailable && (React.createElement("div", { className: css(styles.moreButton, classObject), onClick: getNextPage }, "\u3055\u3089\u306B\u8AAD\u307F\u8FBC\u3080"))));
};
